import { jsx as _jsx } from "react/jsx-runtime";
import { EventBadge } from './EventBadge';
import { sortBadgesByPriority } from '../../utils/badge-evaluator';
/**
 * BadgeGroup Component
 * Displays multiple badges with proper spacing and priority ordering
 */
export const BadgeGroup = ({ badges, maxBadges = 3, size = 'standard', showIcons = true, showText = true, animated = true, className = '', }) => {
    // Sort badges by priority using utility and limit
    const sortedBadges = sortBadgesByPriority(badges).slice(0, maxBadges);
    if (sortedBadges.length === 0) {
        return null;
    }
    return (_jsx("div", { className: `flex flex-wrap gap-1.5 ${className}`, role: "group", "aria-label": "Event badges", children: sortedBadges.map((badgeType) => (_jsx(EventBadge, { type: badgeType, size: size, showIcon: showIcons, showText: showText, animated: animated }, badgeType))) }));
};
BadgeGroup.displayName = 'BadgeGroup';
